import type { RawTilesetEntry } from "../tilesetConfigEntry";

export const effectEntries: RawTilesetEntry[] = [
	{
		key: "Smoke",
		animations: [
			{
				loop: true,
				frames: [
					{ filename: "Smoke_0.png", interval: 90 },
					{ filename: "Smoke_1.png", interval: 90 },
					{ filename: "Smoke_2.png", interval: 90 },
					{ filename: "Smoke_3.png", interval: 90 },
				],
			},
		],
	},
	{
		key: "BigExplosion",
		animations: [
			{
				height: 3,
				width: 3,
				offsetX: -1,
				offsetY: -1,
				loop: false,
				frames: [
					{ filename: "ExplosionB_0.png", interval: 41 },
					{ filename: "ExplosionB_1.png", interval: 41 },
					{ filename: "ExplosionB_2.png", interval: 41 },
					{ filename: "ExplosionB_3.png", interval: 34 },
					{ filename: "ExplosionB_4.png", interval: 33 },
				],
			},
		],
	},
	{
		key: "Explosion",
		animations: [
			{
				loop: false,
				frames: [
					{ filename: "ExplosionB_0.png", interval: 41 },
					{ filename: "ExplosionB_1.png", interval: 41 },
					{ filename: "ExplosionB_2.png", interval: 41 },
					{ filename: "ExplosionB_3.png", interval: 34 },
					{ filename: "ExplosionB_4.png", interval: 33 },
				],
			},
		],
	},
	{
		key: "Hit",
		animations: [
			{
				loop: false,
				frames: [
					{ filename: "Flash_2.png", interval: 60 },
					{ filename: "Flash_4.png", interval: 60 },
					{ filename: "Flash_5.png", interval: 60 },
				],
			},
		],
	},
	// Sword attack variants — placeholder, all mirror the Hit animation for now. Replace
	// each entry's frames independently when dedicated sprites land.
	{
		key: "LungeHit",
		animations: [
			{
				width: 1.5,
				height: 1.5,
				offsetX: -0.25,
				offsetY: -0.25,
				loop: false,
				frames: [
					{ filename: "Flash_2.png", interval: 60 },
					{ filename: "Flash_4.png", interval: 60 },
					{ filename: "Flash_5.png", interval: 60 },
				],
			},
		],
	},
	{
		key: "SlashHit",
		animations: [
			{
				loop: false,
				frames: [
					{ filename: "Flash_2.png", interval: 60 },
					{ filename: "Flash_4.png", interval: 60 },
					{ filename: "Flash_5.png", interval: 60 },
				],
			},
		],
	},
	{
		key: "JabHit",
		animations: [
			{
				loop: false,
				frames: [
					{ filename: "Flash_2.png", interval: 60 },
					{ filename: "Flash_4.png", interval: 60 },
					{ filename: "Flash_5.png", interval: 60 },
				],
			},
		],
	},
	{
		key: "DirectionalSlash",
		allowTransform: true,
		animations: [
			{
				loop: false,
				pointsTo: ["E"],
				width: 3,
				height: 3,
				offsetX: -1,
				offsetY: -1,
				frames: [
					// { filename: "Slash_E_00.png", interval: 23 },
					{ filename: "Slash_E_01.png", interval: 26 },
					{ filename: "Slash_E_02.png", interval: 26 },
					{ filename: "Slash_E_03.png", interval: 26 },
					{ filename: "Slash_E_04.png", interval: 26 },
					{ filename: "Slash_E_05.png", interval: 26 },
					{ filename: "Slash_E_06.png", interval: 26 },
					{ filename: "Slash_E_07.png", interval: 26 },
					{ filename: "Slash_E_08.png", interval: 26 },
					{ filename: "Slash_E_09.png", interval: 26 },
					{ filename: "Slash_E_10.png", interval: 26 },
					// { filename: "Slash_E_11.png", interval: 23 },
					// { filename: "Slash_E_12.png", interval: 23 },
				],
			},
			{
				loop: false,
				pointsTo: ["SE"],
				width: 3,
				height: 3,
				offsetX: -1,
				offsetY: -1,
				frames: [
					// { filename: "Slash_SE_00.png", interval: 29 },
					// { filename: "Slash_SE_01.png", interval: 29 },
					{ filename: "Slash_SE_02.png", interval: 33 },
					{ filename: "Slash_SE_03.png", interval: 33 },
					{ filename: "Slash_SE_04.png", interval: 33 },
					{ filename: "Slash_SE_05.png", interval: 33 },
					{ filename: "Slash_SE_06.png", interval: 33 },
					{ filename: "Slash_SE_07.png", interval: 33 },
					{ filename: "Slash_SE_08.png", interval: 33 },
					{ filename: "Slash_SE_09.png", interval: 33 },
				],
			},
		],
	},
	{
		key: "DirectionalSlash3Tile",
		allowTransform: true,
		animations: [
			{
				loop: false,
				pointsTo: ["N"],
				width: 3,
				height: 3,
				offsetX: -1,
				offsetY: -1,
				frames: [
					{ filename: "Slash_3tile_N_0.png", interval: 60 },
					{ filename: "Slash_3tile_N_1.png", interval: 60 },
					{ filename: "Slash_3tile_N_2.png", interval: 60 },
					{ filename: "Slash_3tile_N_3.png", interval: 120 },
				],
			},
			{
				loop: false,
				pointsTo: ["NW"],
				width: 3,
				height: 3,
				offsetX: -1,
				offsetY: -1,
				frames: [
					{ filename: "Slash_3tile_NW_0.png", interval: 60 },
					{ filename: "Slash_3tile_NW_1.png", interval: 60 },
					{ filename: "Slash_3tile_NW_2.png", interval: 60 },
					{ filename: "Slash_3tile_NW_3.png", interval: 120 },
				],
			},
		],
	},
	{
		key: "CameraFlash",
		animations: [
			{
				loop: false,
				frames: [
					{ filename: "WhiteSquareSolid.png", interval: 240 },
					{ filename: "WhiteSquareSolid.png", interval: 1 },
				],
			},
		],
	},
	{
		key: "ShockBlast",
		animations: [
			{
				loop: false,
				frames: [
					{ filename: "Shock_Effect_0.png", interval: 60 },
					{ filename: "Shock_Effect_1.png", interval: 60 },
					{ filename: "Shock_Effect_2.png", interval: 60 },
				],
			},
		],
	},
	{
		key: "BigShockBlast",
		animations: [
			{
				height: 3,
				width: 3,
				offsetX: -1,
				offsetY: -1,
				loop: false,
				frames: [
					{ filename: "BlueExplosion_0.png", interval: 41 },
					{ filename: "BlueExplosion_1.png", interval: 41 },
					{ filename: "BlueExplosion_2.png", interval: 41 },
					{ filename: "BlueExplosion_3.png", interval: 34 },
					{ filename: "BlueExplosion_4.png", interval: 33 },
				],
			},
		],
	},
	{
		key: "BlueExplosion",
		animations: [
			{
				loop: false,
				frames: [
					{ filename: "BlueExplosion_0.png", interval: 41 },
					{ filename: "BlueExplosion_1.png", interval: 41 },
					{ filename: "BlueExplosion_2.png", interval: 41 },
					{ filename: "BlueExplosion_3.png", interval: 34 },
					{ filename: "BlueExplosion_4.png", interval: 33 },
				],
			},
		],
	},
	{
		key: "BigShockBlast_old",
		animations: [
			{
				height: 3,
				width: 3,
				offsetX: -1,
				offsetY: -1,
				loop: false,
				frames: [
					{ filename: "Shock_Effect_0.png", interval: 60 },
					{ filename: "Shock_Effect_1.png", interval: 60 },
					{ filename: "Shock_Effect_2.png", interval: 60 },
				],
			},
		],
	},
	{
		key: "FadeIn",
		animations: [
			{
				loop: false,
				frames: [
					{ filename: "Black.png", interval: 1 },
					{ filename: "Blank.png", interval: 1 },
				],
			},
		],
	},
	{
		key: "FadeOut",
		animations: [
			{
				loop: false,
				frames: [
					{ filename: "Blank.png", interval: 1 },
					{ filename: "Black.png", interval: 1 },
				],
			},
		],
	},
	{
		key: "SmokeEffect",
		animations: [
			{
				loop: false,
				frames: [
					{ filename: "Smoke_0.png", interval: 47 },
					{ filename: "Smoke_1.png", interval: 47 },
					{ filename: "Smoke_2.png", interval: 47 },
					{ filename: "Smoke_3.png", interval: 47 },
				],
			},
		],
	},
	{
		key: "FlashBlinkingEffect",
		animations: [
			{
				loop: false,
				frames: [
					{ filename: "WhiteSquareSolid.png", interval: 100 },
					{ filename: "Blank.png", interval: 70 },
					{ filename: "WhiteSquareSolid.png", interval: 100 },
					{ filename: "Blank.png", interval: 70 },
					{ filename: "WhiteSquareSolid.png", interval: 100 },
					{ filename: "Blank.png", interval: 70 },
					{ filename: "WhiteSquareSolid.png", interval: 100 },
					{ filename: "Blank.png", interval: 70 },
				],
			},
		],
	},
	{
		key: "BigContainerOpening",
		animations: [
			{
				loop: false,
				height: 4,
				width: 4,
				offsetX: -1,
				offsetY: -1,
				frames: [
					{ filename: "BigBoxOpening_0.png", interval: 80 },
					{ filename: "BigBoxOpening_1.png", interval: 80 },
					{ filename: "BigBoxOpening_2.png", interval: 80 },
					{ filename: "BigBoxOpening_3.png", interval: 80 },
					{ filename: "BigBoxOpening_4.png", interval: 80 },
					{ filename: "BigBoxOpening_5.png", interval: 80 },
					{ filename: "BigBoxOpening_6.png", interval: 400 },
				],
			},
		],
	},
	{
		key: "ShockEffect",
		animations: [
			{
				loop: false,
				frames: [
					{ filename: "Shock_0.png", interval: 60 },
					{ filename: "Shock_1.png", interval: 60 },
					{ filename: "Shock_0.png", interval: 60 },
					{ filename: "Shock_1.png", interval: 60 },
				],
			},
		],
	},
	{
		key: "CircleEffect",
		animations: [
			{
				loop: false,
				frames: [
					{ filename: "CircleEffect_0.png", interval: 30 },
					{ filename: "CircleEffect_1.png", interval: 40 },
					{ filename: "CircleEffect_2.png", interval: 20 },
					{ filename: "CircleEffect_3.png", interval: 10 },
					{ filename: "CircleEffect_4.png", interval: 10 },
					{ filename: "CircleEffect_5.png", interval: 10 },
					{ filename: "CircleEffect_6.png", interval: 10 },
					{ filename: "CircleEffect_7.png", interval: 10 },
				],
			},
		],
	},
	{
		key: "Laser",
		allowTransform: true,
		animations: [
			{
				loop: false,
				pointsTo: ["N", "S"],
				frames: [
					{ filename: "Laser_NS_0.png", interval: 70 },
					{ filename: "Laser_NS_1.png", interval: 60 },
					{ filename: "Laser_NS_2.png", interval: 50 },
					{ filename: "Laser_NS_3.png", interval: 40 },
					{ filename: "Laser_NS_4.png", interval: 30 },
					{ filename: "Laser_NS_5.png", interval: 30 },
				],
			},
			{
				loop: false,
				pointsTo: ["NE", "SW"],
				frames: [
					{ filename: "Laser_NESW_0.png", interval: 70 },
					{ filename: "Laser_NESW_1.png", interval: 60 },
					{ filename: "Laser_NESW_2.png", interval: 50 },
					{ filename: "Laser_NESW_3.png", interval: 40 },
					{ filename: "Laser_NESW_4.png", interval: 30 },
					{ filename: "Laser_NESW_5.png", interval: 30 },
				],
			},
		],
	},
];
